<template>
  <div style="height: 100%; overflow: hidden">
    <!-- <div
      style="
        height: 14vw;
        width: 100vw;
        position: relative;
        background-color: rgb(245, 247, 251);
      "
    >
      <img
        src="../../img/qpxq/return.png"
        alt=""
        style="width: 6vw; margin-top: 2vw; margin-left: 4vw"
        @click="goback()"
      />
      <div class="bt">选择地址</div>
    </div> -->
    <div class="list-container">
      <van-address-list v-model="clientpid" :list="list" />
      <van-button
        class="van-zdy"
        type="primary"
        color="#1989fa"
        @click="addrchange()"
        >确定</van-button
      >
    </div>
  </div>
</template>

<script>
import {  getAddrDetailByTel } from "../../api/ZghApi/ZghAx";
export default {
  props: ["clientfpid"],
  data() {
    return {
      list: [],
      clientpid: this.clientfpid,
      tel: localStorage.getItem("tel"),
      // tel: "15860832301",
    };
  },
  components: {},
  created() {
    this.getAddrDetailByTel();
  },
  destroyed() {},
  computed: {},
  mounted() {},
  watch: {},
  methods: {
    addrchange() {
      for (let index = 0; index < this.list.length; index++) {
        const element = this.list[index];
        if (element.id == this.clientpid) {
          this.$emit("setclientfpid", element);
        }
      }
    },
    getAddrDetailByTel() {
      getAddrDetailByTel({ tel: this.tel }).then((res) => {
        if (res.list == null || res.list.length == 0) {
          this.$toast("未查询到地址信息，请联系管理员！");
        } else {
          this.list = res.list;
        }   
      });
    },
    goback() {
      this.$router.push({ name: "xd" });
    },
  },
};
</script>
<style scoped>
.bt {
  position: absolute;
  left: 35vw;
  top: 4vw;
  width: 30vw;
  text-align: center;
  font-size: 5vw;
  font-weight: 600;
}
.zt1 {
  font-size: 4vw;
  font-weight: 500;
}
.list-container {
  padding: 1vw 3.6% 4.6%;
  height: 75%;
  overflow-y: auto;
}
.van-address-item__edit {
  display: none;
}
.van-address-item__value {
  padding-right: 1vw;
}
/deep/.van-address-item .van-radio__icon--checked .van-icon {
  background-color: #1989fa !important;
  border: 1px solid #1989fa !important;
}
.van-button--round {
  border-radius: 10px;
}
.van-address-list__bottom {
  display: none;
}
.van-zdy {
  position: absolute;
  bottom: 10vw;
  width: 92vw;
  left: 4vw;
  border-radius: 10px;
}
.van-button--danger {
  color: #fff;
  background-color: #1989fa;
  border: 1px solid #1989fa;
}
.van-address-item__address {
  /* position: relative !important;
  top: -7.5vw !important; */
  /* font-size: 4vw; */
}
.van-address-item__name {
  /* position: relative !important;
  top: 6vw !important; */
  /* font-size: 3.5vw; */
}
.van-cell {
  background-color: rgb(247, 248, 250);
}
.van-address-item {
  background-color: rgb(247, 248, 250);
}
</style>



// WEBPACK FOOTER //
// src/views/Home/addr.vue